module.exports = __webpack_public_path__ + "static/media/GTE_Logo_Zusatzrechts_GmbH_RGB.0b63ebf0.png";